// extracted by mini-css-extract-plugin
export default {"header":"Header_header__S9+4Z","img":"Header_img__5ovVw","loginBlock":"Header_loginBlock__cuqQ0"};